import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';

import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.blueDark};
    background: ${COLORS.blueLight};
    border-color: ${COLORS.blue};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.blueDark};
    }
  }
`;

const DefaultRateTag = (props) => <StyledTag label="Default Rate" {...props} />;

export default memo(DefaultRateTag);
